<template>
  <div class="content">
    <div class="tips-box">
      扫一扫功能用于门店加入活动、活动克隆及顾客核销等。
    </div>
    <div class="btn-box">
      <van-button block color="#FF6B31" @click="startSacnning">开始扫码</van-button>
      <van-button block plain  color="#FF6B31" @click="goBack">返回</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {QrCodeEnum} from '@/utils/constant'
import { scan } from "@/utils/native-funs"
import Bus from "@/utils/bus";
export default {
  name: 'Scan',
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
      userInfo: 'userInfo'
    }),
  },
  data() {
    return {
      isScanning: false
    }
  },
  methods: {
    startSacnning() {
      if (this.isScanning) {
        return;
      }
      this.isScanning = true;

      const scanFail = () => {
        this.$dialog.alert({
          message: '微信扫码调用失败，请重试！'
        });
      }
      scan(this.afterScan, scanFail, () => {this.isScanning = false; });
    },
    afterScan(resultStr) {
      console.log('扫一扫参数:',resultStr)
      this.isScanning = false;
      const result = JSON.parse(resultStr.resultStr || resultStr);

      let redirectParam;
      switch (result.type) {
        case QrCodeEnum.join:
          redirectParam = {
            path: '/activity-home',
            query: {
              activityId: result.activityId,
              from: 'join',
            }
          };
          break;
        case QrCodeEnum.clone:
          redirectParam = {
            // path: '/activity/edit',
            path: result.creationMode == 'new' ? '/newActivity/create' : '/activity/edit',
            query: {
              activityId: result.activityId,
              from: 'clone',
              creationMode: result.creationMode,
              tmpType: result.tmpType
            }
          };
          break;
        case QrCodeEnum.verifySign:
          console.log('报名', QrCodeEnum.verifySign)
          redirectParam = {
            path: '/verify',
            query: {
              activityId: result.activityId,
              itemId: result.itemId,
              type: QrCodeEnum.verifySign
            }
          };
          break;
        case QrCodeEnum.lottery:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.lottery
            }
          };
          break;
        case QrCodeEnum.spike:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.spike
            }
          };
          break;
        case QrCodeEnum.group:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.group
            }
          };
          break;
        case QrCodeEnum.drawLots:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.drawLots
            }
          };
          break;
        case QrCodeEnum.countMoney:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.countMoney
            }
          };
          break;
        case QrCodeEnum.coupon:
          redirectParam = {
            path: '/verify',
            query: {
              id: result.id,
              type: QrCodeEnum.coupon
            }
          };
          break;
        default:
          break;
      }

      // 导购不能克隆
      if (this.isGuide) {
        const message = result.type == QrCodeEnum.join
          ? '抱歉，您无当前活动的加入权限！'
            : result.type == QrCodeEnum.clone
              ? '抱歉，您无当前活动的克隆权限！'
                : '';

        if (message) {
          this.$dialog.alert({
            message
          });
          return;
        }
      } else if (this.isTeacher) {
        const message = result.type == QrCodeEnum.join
          ? '抱歉，您无当前活动的加入权限！'
            : result.type == QrCodeEnum.verifySign
              ? '抱歉，您无当前活动的核销权限！'
                : '';

        if (message) {
          this.$dialog.alert({
            message
          });
          return;
        }
      }
      if (redirectParam) {
        this.$router.push(redirectParam);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  created() {
    Bus.$on("androidOnScanCallBack", this.afterScan);
  },

}
</script>

<style lang="stylus" scoped>
.content
  padding 0 50px
  .tips-box
    display: flex
    justify-content: center
    align-items: center
    height 50vh
    font-size 16px
    line-height 2
    text-align: center
  .btn-box
    button
      border-radius 8px
    button+button
      margin-top 15px

</style>